import gql from 'graphql-tag';

export const CONFIG_VALUES_AGGREGATION_QUERY = gql`
  query ConfigValuesAggregationQuery(
    $entityName: String!
    $filters: JSONString!
    $limit: Int!
    $order: String!
    $projectName: String!
    $configKey: String!
    $configType: String!
  ) {
    project(name: $projectName, entityName: $entityName) {
      id
      runs(first: $limit, order: $order, filters: $filters) {
        configValues(configKey: $configKey, configType: $configType)
        configValuesNumberAggregation(configKey: $configKey)
        __typename
      }
      __typename
    }
  }
`;

export const CONFIG_VALUES_CATEGORIES_QUERY = gql`
  query ConfigValuesCategoriesQuery(
    $entityName: String!
    $filters: JSONString!
    $limit: Int!
    $order: String!
    $projectName: String!
    $configKey: String!
    $configType: String!
  ) {
    project(name: $projectName, entityName: $entityName) {
      id
      runs(first: $limit, order: $order, filters: $filters) {
        configValues(configKey: $configKey, configType: $configType)
        configValuesCategories(configKey: $configKey, limit: $limit)
        __typename
      }
      __typename
    }
  }
`;
